import { ReactNode } from "react";
import styled from "styled-components";
// import AppHeader from "layouts/AppHeader";
import AppContainer from "layouts/AppContainer";
import AppFooter from "layouts/AppFooter";

type DefaultLayoutProps = {
  children: ReactNode;
};

const PageWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  flex-flow: column;
  min-height: 100vh;
  /* padding-top: 5rem; */

  #content {
    margin: 0 auto;
    /* padding: 0 3.2rem 8rem; */
  }

  /* #content.page_error {
    padding-bottom: 0;
  } */
`;

const DefaultLayout = ({ children }: DefaultLayoutProps) => {
  return (
    <>
      <PageWrapper>
        {/* <AppHeader />
        <hr /> */}
        <AppContainer>{children}</AppContainer>
        <hr />
        <AppFooter />
      </PageWrapper>
    </>
  );
};

export default DefaultLayout;
